export default __webpack_public_path__ + "static/media/aiSpeechInActive.dfb47ef4.svg";